import { useQueryClient } from "@tanstack/react-query";
import { useCallback } from "react";
import { useResourceContext } from "react-admin";
import { useNavigate } from "react-router-dom";

export const useGoToPreviousPage = (invalidate = true) => {
  const resource = useResourceContext();
  const navigate = useNavigate();

  const queryClient = useQueryClient();

  return useCallback(() => {
    console.log("invalidate", invalidate);

    if (invalidate) {
      queryClient.invalidateQueries({
        queryKey: [resource]
      });
    }

    window.history.state && window.history.state.idx > 0 ? navigate(-1) : navigate(`/${resource}`);
  }, [invalidate, navigate, queryClient, resource]);
};
